
<script>
  export default {
    name: "previd-ia",
    data() {
      return {
        userInput: "",
        chatHistory: [],
        loading: false
      };
    },
    methods: {
      async sendMessage() {
        const message = this.userInput.trim();
        if (!message) return;
  
        // Adiciona a mensagem do usuário
        this.chatHistory.push({ role: 'user', content: message });
        this.userInput = ''; // Limpa o campo de entrada
  
        // Exibe o indicador de carregamento
        this.loading = true;
  
        try {
          // Envia a mensagem para o servidor
          const response = await fetch('http://localhost:3000/chat_p.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ messages: this.chatHistory })
          });
  
          const data = await response.json();
  
          // Adiciona a resposta do bot
          const botMessage = data.choices[0].message.content;
          this.chatHistory.push({ role: 'assistant', content: botMessage });
        } catch (error) {
          // Adiciona uma mensagem de erro
          this.chatHistory.push({ role: 'assistant', content: 'Erro ao processar a mensagem. Tente novamente.' });
        } finally {
          // Oculta o indicador de carregamento
          this.loading = false;
          this.$nextTick(() => {
            this.scrollToBottom();
          });
        }
      },
      formatResponse(response) {
        // Substitui *** por <strong> (negrito)
        response = response.replace(/\*\*\*(.*?)\*\*\*/g, '<strong>$1</strong>');
  
        // Substitui ** por <strong> (negrito)
        response = response.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  
        // Substitui _ por <em> (itálico)
        response = response.replace(/_(.*?)_/g, '<em>$1</em>');
  
        // Substitui ## por <h2> (título)
        response = response.replace(/##(.*?)\n/g, '<h2>$1</h2>');
  
        response = response.replace(/\n/g, '<br>');
  
        return response;
      },
      scrollToBottom() {
        const chatMessages = this.$refs.chatMessages;
        chatMessages.scrollTop = chatMessages.scrollHeight;
      },
      copyToClipboard(message) {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = this.formatResponse(message);
        document.body.appendChild(tempElement);
  
        const range = document.createRange();
        range.selectNodeContents(tempElement);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
  
        try {
          document.execCommand('copy');
          alert('Mensagem copiada!');
        } catch (err) {
          alert('Erro ao copiar a mensagem');
        }
  
        document.body.removeChild(tempElement);
      }
    }
  };
</script>


<template>
  <div class="chat-container">
    <div class="chat-header">
      PREVID.IA
    </div>
    <div class="chat-messages" ref="chatMessages">
      <!-- Mensagens do chat serão exibidas aqui -->
      <div v-for="(message, index) in chatHistory" :key="index" :class="['message', message.role]">
        <span v-html="formatResponse(message.content)"></span>
        <template v-if="message.role === 'assistant'">
          <button class="copy-button" @click="copyToClipboard(message.content)">Copiar</button>
        </template>
      </div>
    </div>
    <div v-if="loading" class="loading">
      <div class="spinner"></div>
      <p>Aguardando IA responder...</p>
    </div>
    <div class="chat-input">
      <input v-model="userInput" @keydown.enter="sendMessage" placeholder="Digite sua mensagem..." />
      <button @click="sendMessage">Enviar</button>
    </div>
  </div>
</template>
  
<style scoped>
  
  .chat-container {
    width: 80%;
    height: 80vh;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    overflow: scroll;
    display: flex;
    flex-direction: column;
  }
  
  .chat-header {
    background-color: #007bff;
    color: #fff;
    padding: 10px;
    text-align: center;
    font-size: 18px;
  }
  
  .chat-messages {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 10px;
    overflow-y: auto;
    border-bottom: 1px solid #ddd;
    max-height: 95%;
  }
  
  .message {
    margin-bottom: 10px;
    padding: 8px;
    border-radius: 5px;
    max-width: 70%;
    word-wrap: break-word;
    white-space: pre-wrap;
  }
  
  .message.user {
    background-color: #007bff;
    color: #fff;
    align-self: flex-end;
  }
  
  .message.assistant {
    background-color: #f1f1f1;
    color: #333;
    align-self: flex-start;
  }
  
  .chat-input {
    display: flex;
    border-top: 1px solid #ddd;
  }
  
  .chat-input input {
    flex: 1;
    padding: 10px;
    border: none;
    outline: none;
  }
  
  .chat-input button {
    padding: 10px;
    background-color: #007bff;
    color: #fff;
    border: none;
    cursor: pointer;
  }
  
  .chat-input button:hover {
    background-color: #0056b3;
  }
  
  .chat-messages::-webkit-scrollbar {
    width: 8px;
  }
  
  .chat-messages::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  .chat-messages::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
  
  .chat-messages::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  
  .loading {
    text-align: center;
    padding: 10px;
    color: #007bff;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  .spinner {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #007bff;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    animation: spin 1s linear infinite;
    margin: 0 auto;
  }
  
  .copy-button {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
    margin-left: 10px;
  }
  
  .copy-button:hover {
    background-color: #0056b3;
  }
</style>
  


// WEBPACK FOOTER //
// src/js/components/previd-ia.vue